let HELPER_BASE = process.env.VUE_APP_HELPER_BASE,
  APP_ASSETS_BASE_URL = process.env.VUE_APP_ASSETS_CDN_BASE_URL,
  ASSETS_CDN_BASE_URL = process.env.VUE_APP_CDN_BASE_URL,
  LD_CONTEXT_KEY = process.env.VUE_APP_LD_CONTEXT_KEY,
  GB_SDK_KEY = process.env.VUE_APP_GB_SDK_KEY;
let DEFAULT_SEO_TITLE;
let FETCH_FEATURE_FLAGS_INTERVAL;

FETCH_FEATURE_FLAGS_INTERVAL = parseInt(
  process.env.VUE_APP_FETCH_FEATURE_FLAGS_INTERVAL
);

DEFAULT_SEO_TITLE =
  "VisitorsCoverage Insurance for USA visitors, Int'l Travel medical Insurance, Visitor Health Insurance";

if (typeof VC_PUBLIC_CUSTOM_BASE_URL !== "undefined") {
  HELPER_BASE = VC_PUBLIC_CUSTOM_BASE_URL;
}

export {
  HELPER_BASE,
  APP_ASSETS_BASE_URL,
  ASSETS_CDN_BASE_URL,
  DEFAULT_SEO_TITLE,
  FETCH_FEATURE_FLAGS_INTERVAL,
  LD_CONTEXT_KEY,
  GB_SDK_KEY,
};
